import "./myprofile.scss";
import file from "./images/file.svg";

import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { inject, observer } from "mobx-react";

import ContractModal from "../Files/ContractModal";
import ProcessingDataModal from "../Files/ProcessingDataModal";
import DownloadFiles from "../Files/DownloadFiles";
import LoadedComponent from "./LoadedComponent/index";
import Information from "./Information/index";
import Foto from "./Foto/index";

const MyProfile = ({
  cleanFilesSuccess,
  token,
  getUserData,
  userFiles,
  getStaticPage,
  offer,
  personalDataPolicy,
  isLoading,
  getFiles
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      setTimeout(() => {
        navigate(`/allvacancies`);
      }, 500);
    }
  }, [token]);

  useEffect(() => {
    getUserData({ newToken: token });
    getFiles();
    getStaticPage("offerAgreement");
    getStaticPage("personalDataPolicy");
  }, []);

  const newData = () => {
    getUserData({ newToken: token });
    getFiles();
    getStaticPage("offerAgreement");
    getStaticPage("personalDataPolicy");
    cleanFilesSuccess();
  };

  const [modalContractShow, setModalContractShow] = useState(false);
  const [modalProcessingDataShow, setModalProcessingDataShow] = useState(false);
  const [modalDownloadFilesShow, setModalDownloadFilesShow] = useState(false);

  return (
    <LoadedComponent isLoading={isLoading}>
      <div className="myprofile">
        <Foto userFiles={userFiles} />
        <Information getUserData={getUserData} newData={newData} />
        <div className="myprofile__documents">
          <div
            className="myprofile__documents-string"
            onClick={() => setModalDownloadFilesShow(true)}
          >
            <img src={file} className="myprofile__documents-img " alt="" />
            <p className="myprofile__documents-subtitle">
              Список документов для кандидатов
            </p>
          </div>
          <div
            className="myprofile__documents-string"
            onClick={() => setModalContractShow(true)}
          >
            <img src={file} className="myprofile__documents-img " alt="" />
            <p className="myprofile__documents-subtitle">
              Договор оферты о сотрудничестве
            </p>
          </div>
          <div
            className="myprofile__documents-string"
            onClick={() => setModalProcessingDataShow(true)}
          >
            <img src={file} className="myprofile__documents-img " alt="" />
            <p className="myprofile__documents-subtitle">
              Политика конфиденциальности
            </p>
          </div>
          <div className="d-flex justify-content-center flex-row">
            <ContractModal
              show={modalContractShow}
              onHide={() => setModalContractShow(false)}
              offer={offer}
            />
            <ProcessingDataModal
              show={modalProcessingDataShow}
              onHide={() => setModalProcessingDataShow(false)}
              personalDataPolicy={personalDataPolicy}
            />
            <DownloadFiles
              show={modalDownloadFilesShow}
              onHide={() => setModalDownloadFilesShow(false)}
            />
          </div>
        </div>
      </div>
    </LoadedComponent>
  );
};

export default inject(({ usersStore, documentsStore, filesStore }) => {
  const { cleanFilesSuccess } = filesStore;
  const { token, userFiles, getUserData, isLoading } = usersStore;
  const { getFiles, getStaticPage, offer, personalDataPolicy } = documentsStore;

  return {
    cleanFilesSuccess,
    token,
    userFiles,
    getUserData,
    isLoading,
    getFiles,
    getStaticPage,
    offer,
    personalDataPolicy
  };
})(observer(MyProfile));
